import React from "react"
import { appPlayerProfilePath } from "../../App/paths"
import Avatar from "../../Avatar"
import { Round, TeamPlayer } from "../../types"

interface HeaderProps {
  round: Round
  teamPlayers: TeamPlayer[]
}

export default function Header({ round, teamPlayers }: HeaderProps) {
  return (
    <>
      {!round.cancelationText && teamPlayers ? <RegisteredPlayers round={round} teamPlayers={teamPlayers} /> : null}
    </>
  )
}

interface RegisteredPlayersProps {
  round: Round
  teamPlayers: TeamPlayer[]
}

function RegisteredPlayers({ round, teamPlayers }: RegisteredPlayersProps) {
  const backPath = `${window.location.pathname}${window.location.search}`

  return (
    <div className="team-registered-players">
      {teamPlayers.map((tp) => {
        return (
          <a
            key={tp.id}
            href={appPlayerProfilePath(tp.sqid, {
              back_path: backPath,
              round_id: round.id,
              league_id: round.league.id
            })}
            style={{ textAlign: "center", textDecoration: "none", color: "inherit", cursor: "pointer" }}
          >
            <Avatar user={tp} size="large" className={tp.status === "registered" ? "registered" : "not-registered"} />
            <div style={{ fontWeight: "bold" }}>{tp.name}</div>
          </a>
        )
      })}
    </div>
  )
}
